<template>
  <aside class="aside">
    <nav class="nav">
      <ul class="flex_column">
        <!-- Tablet일 경우 햄버거바/로고-->
        <li class="tablet-logo-hambuger-wrap">
          <img
            @click="clickAside"
            class="common-hambugerbar-img cursor"
            src="/media/images/icon/hambugerbar-icon.png"
            alt="hambugerbar-img.png"
          />
          <img @click="onClickLogo" class="common-logo-img" src="/media/images/logo/aplayz-logo-red.png" alt="logo" />
        </li>
        <!-- 사용자 이메일-->
        <li class="align_center user-emailwrap">
          <span class="user-email">{{ email }}</span>
        </li>
        <!-- Bar -->
        <li class="menu-middle-bar"></li>
        <!-- 메뉴 리스트-->
        <li>
          <!-- 서비스 메뉴-->
          <ul class="service-menu">
            <li>
              <router-link
                :to="{
                  path: '/main'
                }"
                class="service-menu-item"
              >
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Main'
                        ? '/media/images/icon/home-active-icon.png'
                        : '/media/images/icon/home-icon.png'
                    "
                    alt="home-active-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Main' ? 'active' : ''">홈</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/myspace' }" class="service-menu-item">
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'MySpace'
                        ? '/media/images/icon/myspace-active-icon.png'
                        : '/media/images/icon/myspace-icon.png'
                    "
                    alt="myspace-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'MySpace' ? 'active' : ''"
                  >마이스페이스</span
                >
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: '/mymusic' }"
                class="service-menu-item"
                @click.native="onClickMenuClick('my_music')"
              >
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'MyMusic'
                        ? '/media/images/icon/mymusic-active-icon.png'
                        : '/media/images/icon/mymusic-icon.png'
                    "
                    alt="mymusic-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'MyMusic' ? 'active' : ''">마이뮤직</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: '/product' }"
                class="service-menu-item"
                @click.native="onClickMenuClick('ticket')"
              >
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Product'
                        ? '/media/images/icon/subscibe-active-icon.png'
                        : '/media/images/icon/subscibe-icon.png'
                    "
                    alt="subscibe-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Product' ? 'active' : ''">요금제</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: '/payment' }"
                tabindex="0"
                class="service-menu-item"
                @click.native="onClickMenuClick('subscribe_history')"
              >
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Payment'
                        ? '/media/images/icon/subscribeusing-active-icon.png'
                        : '/media/images/icon/subscribeusing-icon.png'
                    "
                    alt="subscibeusing-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Payment' ? 'active' : ''"
                  >이용권 현황</span
                >
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/card' }" tabindex="0" class="service-menu-item">
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Card'
                        ? '/media/images/icon/card-active-icon.png'
                        : '/media/images/icon/card-icon.png'
                    "
                    alt="card-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Card' ? 'active' : ''">결제카드</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: '/coupon' }"
                class="service-menu-item"
                @click.native="onClickMenuClick('coupon')"
              >
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Coupon'
                        ? '/media/images/icon/coupon-active-icon.png'
                        : '/media/images/icon/coupon-icon.png'
                    "
                    alt="coupon-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Coupon' ? 'active' : ''">쿠폰</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/event' }" class="service-menu-item" @click.native="onClickMenuClick('event')">
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'Event'
                        ? '/media/images/icon/event-active-icon.png'
                        : '/media/images/icon/event-icon.png'
                    "
                    alt="event-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Event' ? 'active' : ''">이벤트</span>
              </router-link>
            </li>
          </ul>
          <!-- Bar -->
          <div class="menu-middle-bar sub"></div>
          <!-- 고객센터 -->
          <ul class="service-menu">
            <li>
              <router-link :to="{ path: '/cs' }" class="service-menu-item" @click.native="onClickMenuClick('cs')">
                <div class="icon-group">
                  <img
                    class="iconbox"
                    :src="
                      currentRouteName === 'CS'
                        ? '/media/images/icon/cs-active-icon.png'
                        : '/media/images/icon/cs-icon.png'
                    "
                    alt="myspace-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'CS' ? 'active' : ''">고객센터</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ path: '/profile' }"
                class="service-menu-item"
                @click.native="onClickMenuClick('setting_button')"
              >
                <div class="icon-group">
                  <img
                    class="setting-icon"
                    :src="
                      currentRouteName === 'Profile'
                        ? '/media/images/icon/setting-active-icon.png'
                        : '/media/images/icon/setting-icon.png'
                    "
                    alt="myspace-icon.png"
                  />
                </div>
                <span class="service-meunname" :class="currentRouteName === 'Profile' ? 'active' : ''">설정</span>
              </router-link>
            </li>
          </ul>
          <!-- 이용약관 -->
          <ul class="agree-list">
            <li>
              <router-link :to="{ path: '/policy/service' }" tabindex="0" class="agree-item cursor">
                이용약관
              </router-link>
            </li>
            <li>
              <router-link :to="{ path: '/policy/privacy' }" tabindex="0" class="agree-item cursor">
                개인정보처리방침
              </router-link>
            </li>
          </ul>
          <!-- 로그아웃 -->
          <div class="logout-wrap cursor" @click="onClickLogOut">
            <img class="logout-icon cursor" src="/media/images/icon/logout-icon.png" alt="logout-icon" />
            <span class="logout-text">로그아웃</span>
          </div>
        </li>
      </ul>
    </nav>
  </aside>
</template>
<script>
export default {
  emits: ['logout-confirm', 'click-aside'],
  data() {
    return {};
  },
  methods: {
    onClickMenuClick(menu) {
      this.$gatag.event(`web_my_menu_${menu}`);
    },
    onClickLogOut() {
      this.$gatag.event('web_logout_popup'); // 로그아웃 팝업

      this.$emit('logout-confirm');
    },
    clickAside() {
      this.$emit('click-aside');
    },
    onClickLogo() {
      this.$router.push({ path: '/main' });
    }
  },
  created() {},
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    email() {
      return this.$store.state.email;
    }
  }
};
</script>
<style scoped src="@/assets/css/asidev2/asidev2.css"></style>
